import Styled from "styled-components/macro";

const Form = Styled.form``;

export default Form;
